// packages/lib/constants/FeatureFlags.ts
export enum FeatureFlagKeys {
  LoginButtonTest = 'login-button-test',
  SupportAssistantEnabled = 'support-assistant-enabled',
  BugHerdEnabled = 'bugherd-enabled',
  DemoNewDashboardLayout = 'demo-new-dashboard-layout',
  MobileSetupNavigation = 'mobile-setup-navigation',
  ClientAlertsEnabled = 'client-alerts-enabled',
  BigQueryReporting = 'bigquery-reporting',
  PiiRedactionEnabled = 'pii-redaction-enabled',
  AssistantSidenavEnabled = 'assistant-sidenav-enabled',
  ContentSuiteEnabled = 'content-suite-enabled',
  AnalyticsTabEnabled = 'analytics-tab-enabled',
  CubeGrossRevenueCard = 'cube-gross-revenue-card',
  CubeBookingUtilisationCard = 'cube-booking-utilisation-card',
  ImportUtility = 'import-utility',
  PublicBundledSigning = 'public-bundled-signing',
  SelfServiceEnabled = 'self-service-enabled',
  DelayFirstPaymentEnabled = 'delay-first-payment-enabled',
  DoorAccessEnabled = 'door-access-enabled',
}
